import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  cartFreightRequest: ['cep', 'params'],
  cartFreightSuccess: ['data', 'sellerId'],
  cartFreightFailed: ['error', 'sellerId'],

  productFreightRequest: ['cep'],
  productFreightSuccess: ['data'],
  productFreightFailed: ['error'],

  selectFreight: ['freight'],
});

const INITIAL_STATE = Immutable({
  cartFreight: {},
  error: {},
  isLoading: {},
  productLoading: false,
  productFreight: {},
  selectedFreight: {},
});

const cartFreightRequest = (state = INITIAL_STATE, { params }) =>
  state
    .merge({ cartFreight: state.getIn(['cartFreight']).without(params?.idSeller), error: {} })
    .merge({ isLoading: { [params?.idSeller]: true } }, { deep: true });

const productFreightRequest = (state = INITIAL_STATE) =>
  state.merge({
    error: {},
    productLoading: true,
    productFreight: {},
  });

const errorFreight = (state = INITIAL_STATE, { error, sellerId }) =>
  state.merge({ error }).merge(
    {
      isLoading: { [sellerId]: false },
      productLoading: false,
    },
    { deep: true }
  );

const cartFreightSuccess = (state = INITIAL_STATE, { data, sellerId }) => {
  const cartFreight = state.getIn(['cartFreight']).asMutable();

  data.forEach((seller) => {
    cartFreight[seller.seller.id] = seller;
  });

  return state.merge({ cartFreight }).merge({ isLoading: { [sellerId]: false } }, { deep: true });
};

const productFreightSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge({ productFreight: data, productLoading: false });

const selectFreight = (state = INITIAL_STATE, { freight }) =>
  state.merge({
    selectedFreight: { ...state.getIn(['selectedFreight']), ...freight },
  });

export default createReducer(INITIAL_STATE, {
  [Types.CART_FREIGHT_REQUEST]: cartFreightRequest,
  [Types.CART_FREIGHT_SUCCESS]: cartFreightSuccess,
  [Types.CART_FREIGHT_FAILED]: errorFreight,

  [Types.PRODUCT_FREIGHT_REQUEST]: productFreightRequest,
  [Types.PRODUCT_FREIGHT_SUCCESS]: productFreightSuccess,
  [Types.PRODUCT_FREIGHT_FAILED]: errorFreight,

  [Types.SELECT_FREIGHT]: selectFreight,
});
